'use client';
import { useEffect } from 'react';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const timestamp = new Date().toISOString();
      const errorTag = '[GlobalError]'; // Custom tag to easily identify logs
      const errorDetails = {
        timestamp,
        digest: error.digest || 'No digest available',
        message: error.message,
        stack: error.stack || 'No stack trace available',
        url: window.location.href,
      };
      console.error(`${errorTag} [Timestamp: ${timestamp}] [Digest: ${error.digest || 'N/A'}]`, errorDetails);
    }
  }, []);

  return <></>;
}
